import { Typography, TypographyProps } from '@material-ui/core';
import React from 'react';
import classnames from 'classnames';
import useStyles from './styles';

interface TitleProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  subTitle?: React.ReactNode;
  titleProps?: TypographyProps<any>;
  subTitleProps?: TypographyProps<any>;
}

const Title = (props: TitleProps) => {
  const classes = useStyles();

  return (
    <div>
      <Typography
        variant="h5"
        component="p"
        className={classnames([classes.root, props.className])}
        {...props.titleProps}
        style={{ ...props.style, ...props?.titleProps?.style }}
      >
        {props.children}
      </Typography>
      {props.subTitle && (
        <Typography
          variant="subtitle1"
          component="p"
          className={classnames([classes.subTitle])}
          {...props.subTitleProps}
          style={{ ...props.style, ...props?.subTitleProps?.style }}
        >
          {props.subTitle}
        </Typography>
      )}
    </div>
  );
};

export default React.memo(Title);
